import React, { useEffect, useRef, useState } from "react";
import { TaskExecutionTypeFieldSchema, useBoltApiClient } from "@bolt/core";
import { useFieldSchemaV2, SchemaFactoryV2, FieldFormV2 } from "@ucl/library";
import { TaskExecutionTypeComponent } from "../TaskExecutionTypeComponent/TaskExecutionTypeComponent";

export interface TaskExecutionFieldsLoaderProps {
  taskExecutionType: string;

  taskExecutionTypeFields: TaskExecutionTypeFieldSchema;
  apiBaseUrl?: string;
  getAuthRequestHeader?: () => Promise<Record<string, string> | undefined>;
  onSubmit?: (updated: TaskExecutionTypeFieldSchema) => Promise<void>;
  errors?: Record<string, string[]>;
  isReadOnly?: boolean;
}

export const TaskExecutionFieldsLoader: React.FC<
  TaskExecutionFieldsLoaderProps
> = (props) => {
  const boltApiClient = useBoltApiClient();
  const { getAsyncSchemaFactory } = useFieldSchemaV2("tasks/field-schema");
  const [schemaFactory, setSchemaFactory] = useState<SchemaFactoryV2>();
  const loadingRef = useRef<boolean>(false);

  const getSchema = async () => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setSchemaFactory(await getAsyncSchemaFactory(boltApiClient));
  };

  useEffect(() => {
    getSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!schemaFactory) {
    return (
      <div className="task-execution-fields-loader">Loading schema...</div>
    );
  }

  // Compose the value for TaskExecutionTypeComponent
  const complexFieldValue = {
    key: props.taskExecutionType,
    taskExecutionType: props.taskExecutionType,
    factory: schemaFactory,
    fieldSet: "TaskExecutionTypeField",
    getAuthRequestHeader: props.getAuthRequestHeader || (async () => ({})),
    apiBaseUrl: props.apiBaseUrl || "",
    errors: props.errors || {},
    isReadOnly: props.isReadOnly,
  };

  // const handleSubmit = async (updated: Record<string, any>) => {
  //   // TODO Run Validate and errors
  //   // if success, call onSubmit
  //   // if (props.onSubmit) {
  //   //   await props.onSubmit(updated);
  //   // }
  // };

  return (
    <div className="task-execution-fields-loader">
      <FieldFormV2>
        <TaskExecutionTypeComponent
          value={props.taskExecutionTypeFields}
          complexFieldValue={complexFieldValue}
          onSubmit={props.onSubmit}
        />
      </FieldFormV2>
    </div>
  );
};
